export const getSourceTypeLabel = (type = '') => {
    const normalized = String(type || '').toLowerCase();
    if (normalized.includes('outlook') || normalized === 'email' || normalized === 'mail') return 'Outlook email';
    if (normalized.includes('feed') || normalized.includes('activity')) return 'Activity feed';
    if (normalized.includes('field') || normalized.includes('fusion')) return 'Case field';
    if (normalized.includes('s3')) return 'Selected document';
    if (normalized.includes('case')) return 'Case';
    if (normalized.includes('lead')) return 'Lead';
    if (normalized.includes('file') || normalized.includes('document')) return 'File';
    if (normalized.includes('report')) return 'Report';
    return normalized ? normalized.replace(/[_-]+/g, ' ') : 'Source';
};

export const normalizeAnswerSourceCard = (sourceCard = {}, index = 0) => {
    if (!sourceCard || typeof sourceCard !== 'object') return null;
    const sourceType = String(sourceCard.source_type || sourceCard.type || '').trim();
    const fileId = Number(sourceCard.file_id || 0);
    const caseId = Number(sourceCard.case_id || 0);
    const feedUpdateId = Number(sourceCard.feed_update_id || sourceCard.update_id || 0);
    const fieldId = Number(sourceCard.field_id || sourceCard.custom_field_id || 0);
    const title = String(sourceCard.title || sourceCard.file_name || sourceCard.label || sourceCard.case_name || '').trim();
    const fallbackNumber = Number(sourceCard.number || sourceCard.citation_number || sourceCard.original_number || index + 1);
    const url = String(sourceCard.url || '').trim();
    if (!title && !fileId && !caseId && !url && !sourceType) return null;
    return {
        ...sourceCard,
        number: Number.isFinite(fallbackNumber) && fallbackNumber > 0 ? fallbackNumber : index + 1,
        original_number: sourceCard.original_number || sourceCard.number || sourceCard.citation_number || null,
        source_type: sourceType || (fileId ? 'document' : caseId ? 'case' : 'source'),
        chunk_source: sourceCard.chunk_source || 'source_card',
        file_id: Number.isFinite(fileId) && fileId > 0 ? fileId : null,
        case_id: Number.isFinite(caseId) && caseId > 0 ? caseId : null,
        feed_update_id: Number.isFinite(feedUpdateId) && feedUpdateId > 0 ? feedUpdateId : null,
        field_id: Number.isFinite(fieldId) && fieldId > 0 ? fieldId : null,
        file_name: sourceCard.file_name || title || (fileId ? `File ${fileId}` : ''),
        label: sourceCard.label || title || sourceCard.source_id || `Source ${index + 1}`,
        excerpt: sourceCard.excerpt || sourceCard.description || sourceCard.text || '',
        url,
    };
};

export const getAnswerSourceCards = (answer = null) => (
    Array.isArray(answer?.source_cards) ? answer.source_cards : []
).map(normalizeAnswerSourceCard).filter(Boolean);

export const mergeDisplayedSources = (sourceCards = [], displayedCitations = []) => {
    const merged = [];
    const indexByKey = new Map();
    const add = (source) => {
        if (!source || typeof source !== 'object') return;
        const key = String(
            source.source_id
            || `${source.source_type || source.type || 'source'}:${source.file_id || ''}:${source.case_id || ''}:${source.feed_update_id || ''}:${source.field_id || ''}:${source.url || ''}:${source.number || ''}`
        );
        if (indexByKey.has(key)) {
            const index = indexByKey.get(key);
            const current = merged[index];
            merged[index] = {
                ...source,
                ...current,
                citation_handle: current.citation_handle || source.citation_handle,
            };
            return;
        }
        indexByKey.set(key, merged.length);
        merged.push(source);
    };
    sourceCards.forEach(add);
    displayedCitations.forEach(add);
    return merged;
};
